/* eslint-disable prettier/prettier */
import { ActivityTypeConfig } from '../types/schedule.types';

export const ACTIVITY_TYPES: ActivityTypeConfig[] = [
	{
		id: 'masterclass',
		label: 'Masterclass',
		color: '#2E9E6B', // teal-green bottom border
		bgColor: '#F0FAF5', // very light green bg
		chipBg: '#EEF8F3',
		chipBorder: '#B6E2CE',
	},
	{
		id: 'mentoring_session',
		label: 'Mentoring Session',
		color: '#E5913A', // warm orange
		bgColor: '#FDF6EE',
		chipBg: '#FDF3E7',
		chipBorder: '#F5C98A',
	},
	{
		id: 'assignment',
		label: 'Assessment',
		color: '#7B6FD4', // soft purple/violet
		bgColor: '#F5F4FC',
		chipBg: '#F3F1FB',
		chipBorder: '#C5BFF0',
	},
	{
		id: 'peer_coaching',
		label: 'Peer Coaching Sessions',
		color: '#D94F4F', // muted red
		bgColor: '#FDF2F2',
		chipBg: '#FEF1F1',
		chipBorder: '#F5B8B8',
	},
];

export const ACTIVITY_TYPE_MAP: Record<string, ActivityTypeConfig> =
	Object.fromEntries(ACTIVITY_TYPES.map(t => [t.id, t]));

export const DAY_NAMES_SHORT = [
	'Sun',
	'Mon',
	'Tues',
	'Wed',
	'Thurs',
	'Fri',
	'Sat',
];
export const WEEK_DISPLAY_ORDER = [1, 2, 3, 4, 5, 6, 0]; // Mon–Sun

/** Week view: cards visible per day column before scrolling. */
export const VISIBLE_ACTIVITIES_PER_DAY = 3;

/** Month view: cards visible per day cell before the "+N" pill (Image 2). */
export const MONTH_VISIBLE_ACTIVITIES_PER_DAY = 2;
